import { TablePagination } from 'components/molecules';
import { EvaluationRow } from 'components/molecules/Evaluation/EvaluationRow';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useEvaluation } from 'hooks/useEvaluation';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export const EvaluationList: React.FC = () => {
  const {
    docs,
    totalPages,
    page,
    handleNextPage,
    handlePreviousPage,
    loading,
  } = useEvaluation();

  return (
    <PaperCardTemplate loading={loading}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography fontWeight={500} fontSize={14}>
                Data do Atendimento
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14}>
                Nome do Tutor
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14} color="#4B4B4B">
                Veterinário
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14} color="#4B4B4B">
                CPF
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14}>
                Avaliação
              </Typography>
            </TableCell>

            <TableCell align="right">
              <Typography fontWeight={500} fontSize={14}>
                Ação
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        {docs?.length < 1 && (
          <Typography component="caption">
            <Box textAlign="center">Não possui nenhuma avaliação nesse período.</Box>
          </Typography>
        )}

        <TableBody>
          {docs?.map((evaluation) => (
            <EvaluationRow key={evaluation._id} evaluation={evaluation} />
          ))}
        </TableBody>
      </Table>
      <TablePagination
        currentPage={page}
        maxPage={totalPages}
        onPreviousClick={handlePreviousPage}
        onNextClick={handleNextPage}
      />
    </PaperCardTemplate>
  );
};

